import { createDOMRenderer } from '@griffel/core';

/**
 * Creates a renderer that renders <style> elements if .adoptedStyleSheets is not supported.
 */
const createFallbackRenderer = shadowRoot => {
  const documentFallback = {
    head: shadowRoot,
    createElement: shadowRoot.ownerDocument.createElement.bind(shadowRoot.ownerDocument)
  };
  return createDOMRenderer(documentFallback);
};

export { createFallbackRenderer };
//# sourceMappingURL=createFallbackRenderer.esm.js.map
